import React from 'react';
import { Container } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import List from './List';

const RessourceList = () => {
    const { t } = useTranslation();
    document.title = t('resource_list.title');

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={t('resource_list.title')} pageTitle={t('resource_list.page_title')} />
                    <List />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default RessourceList;